(function ($) {
    $.fn.customSelect = function () {
        return this.each(function () {
            const $select = $(this);
            if ($select.data('custom-select-init')) {
                $select.triggerHandler('custom-select:refresh');
                return;
            }
            $select.data('custom-select-init', true);

            const placeholder = $select.attr('data-placeholder') || '';
            const enableSearch = $select.attr('data-search') === 'true';
            const searchPlaceholder = $select.attr('data-search-placeholder') || 'Keresés...';

            const $wrapper = $('<div class="custom-select-wrapper"></div>');
            const $trigger = $('<div class="custom-select-trigger" tabindex="0"></div>');
            const $panel = $('<div class="custom-select-panel"></div>');

            $select.wrap($wrapper);
            const $parent = $select.parent();
            $parent.append($trigger).append($panel);

            let $search = null;
            let $optionsList = $panel;

            if (enableSearch) {
                const $searchWrap = $('<div class="custom-select-search"></div>');
                $search = $('<input type="text" autocomplete="off" />').attr('placeholder', searchPlaceholder);
                $searchWrap.append($search);
                $optionsList = $('<div class="custom-select-list"></div>');
                $panel.append($searchWrap).append($optionsList);
            }

            function renderOptions() {
                $optionsList.empty();
                $select.find('option').each(function () {
                    const $opt = $(this);
                    if ($opt.attr('hidden') !== undefined && $opt.attr('hidden') !== false) return;
                    if (!$opt.text() && !$opt.val()) return;

                    const $item = $('<div class="custom-select-option"></div>')
                        .text($opt.text())
                        .attr('data-value', $opt.val())
                        .attr('data-label', $opt.text().toLowerCase());

                    const fontFamily = $opt.attr('data-fontfamily');
                    if (fontFamily) {
                        $item.css('font-family', fontFamily);
                    }

                    if ($opt.is(':selected')) {
                        $item.addClass('is-selected');
                    }

                    $optionsList.append($item);
                });
            }

            function filterOptions(query) {
                const q = (query || '').toLowerCase().trim();
                let visibleCount = 0;
                $optionsList.find('.custom-select-option').each(function () {
                    const label = $(this).attr('data-label') || '';
                    const match = !q || label.indexOf(q) !== -1;
                    $(this).toggle(match);
                    if (match) visibleCount++;
                });
                $optionsList.find('.custom-select-empty').remove();
                if (visibleCount === 0) {
                    $optionsList.append('<div class="custom-select-empty">Nincs találat</div>');
                }
            }

            function updateTrigger() {
                const $selected = $select.find('option:selected');
                const hasValue = $selected.length && $selected.text();

                if (hasValue) {
                    $trigger.removeClass('is-placeholder').text($selected.text());
                    const fontFamily = $selected.attr('data-fontfamily');
                    $trigger.css('font-family', fontFamily || '');
                } else {
                    $trigger.addClass('is-placeholder').text(placeholder).css('font-family', '');
                }
            }

            function closePanel() {
                $parent.removeClass('is-open');
                $optionsList.find('.is-active').removeClass('is-active');
            }

            function getVisibleOptions() {
                return $optionsList.find('.custom-select-option:visible');
            }

            function setActive($item, scroll) {
                if (!$item || !$item.length) return;
                $optionsList.find('.is-active').removeClass('is-active');
                $item.addClass('is-active');
                if (scroll !== false) {
                    const itemTop = $item[0].offsetTop;
                    const itemBottom = itemTop + $item[0].offsetHeight;
                    const viewTop = $panel.scrollTop();
                    const viewBottom = viewTop + $panel.height();
                    if (itemTop < viewTop) {
                        $panel.scrollTop(itemTop);
                    } else if (itemBottom > viewBottom) {
                        $panel.scrollTop(itemBottom - $panel.height());
                    }
                }
            }

            function moveActive(direction) {
                const $items = getVisibleOptions();
                if (!$items.length) return;
                const $current = $optionsList.find('.is-active');
                let idx = $items.index($current);
                if (direction === 'down') idx = idx < 0 ? 0 : Math.min(idx + 1, $items.length - 1);
                else if (direction === 'up') idx = idx <= 0 ? $items.length - 1 : idx - 1;
                setActive($items.eq(idx), true);
            }

            function selectActive() {
                const $active = $optionsList.find('.is-active:visible').first();
                if ($active.length) {
                    $active.trigger('click');
                    return true;
                }
                const $first = getVisibleOptions().first();
                if ($first.length) {
                    $first.trigger('click');
                    return true;
                }
                return false;
            }

            function openPanel() {
                $('.custom-select-wrapper.is-open').removeClass('is-open');
                $parent.addClass('is-open');
                if ($search) {
                    $search.val('');
                    filterOptions('');
                    setTimeout(function () {
                        $search.trigger('focus');
                    }, 0);
                }
                const $selected = $optionsList.find('.is-selected:visible');
                if ($selected.length) {
                    setActive($selected, false);
                    const top = $selected.position().top;
                    $panel.scrollTop(top - $panel.height() / 2);
                } else {
                    setActive(getVisibleOptions().first(), false);
                }
            }

            function handleNavKey(e) {
                const isOpen = $parent.hasClass('is-open');
                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (!isOpen) {
                            openPanel();
                        } else {
                            moveActive('down');
                        }
                        return true;
                    case 'ArrowUp':
                        e.preventDefault();
                        if (!isOpen) {
                            openPanel();
                        } else {
                            moveActive('up');
                        }
                        return true;
                }
                return false;
            }

            $trigger.on('click', function (e) {
                e.stopPropagation();
                if ($parent.hasClass('is-open')) {
                    closePanel();
                } else {
                    openPanel();
                }
            });

            $trigger.on('keydown', function (e) {
                if (handleNavKey(e)) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if ($parent.hasClass('is-open')) {
                        if (!selectActive()) closePanel();
                    } else {
                        openPanel();
                    }
                } else if (e.key === 'Escape' || e.key === 'Tab') {
                    if ($parent.hasClass('is-open')) closePanel();
                }
            });

            if ($search) {
                $search.on('click', function (e) {
                    e.stopPropagation();
                });
                $search.on('input', function () {
                    filterOptions($(this).val());
                    setActive(getVisibleOptions().first(), true);
                });
                $search.on('keydown', function (e) {
                    if (handleNavKey(e)) return;
                    if (e.key === 'Escape') {
                        closePanel();
                        $trigger.trigger('focus');
                    } else if (e.key === 'Enter') {
                        e.preventDefault();
                        selectActive();
                    } else if (e.key === 'Tab') {
                        closePanel();
                    }
                });
            }

            $optionsList.on('mouseenter', '.custom-select-option', function () {
                setActive($(this), false);
            });

            $panel.on('click', '.custom-select-option', function (e) {
                e.stopPropagation();
                const value = $(this).attr('data-value');
                $select.val(value).trigger('change');
                $optionsList.find('.is-selected').removeClass('is-selected');
                $(this).addClass('is-selected');
                updateTrigger();
                closePanel();
                $trigger.trigger('focus');
            });

            $select.on('change', updateTrigger);

            $select.on('custom-select:refresh', function () {
                renderOptions();
                updateTrigger();
            });

            renderOptions();
            updateTrigger();
        });
    };

    $(function () {
        if (!$('.custom-select').length) return;

        $('.custom-select').customSelect();

        $(document).on('click', function () {
            $('.custom-select-wrapper.is-open').removeClass('is-open');
        });
    });
})(jQuery);
